import classnames from 'classnames';
import type { ReceivedVision } from '@sorrem/shared';
import { toEssenceEmblemUrl } from '../../compendium-pages';
import styles from './VisionPlate.module.scss';

interface VisionPlateProps {
    vision: ReceivedVision;
    /** Drawn into the Journal's pages rather than shown as a painting. */
    isInked?: boolean;
    className?: string;
}

/**
 * A vision's painted plate. Until its painting exists, a soft wash of light
 * with the vision's essence emblem stands in, so the page never looks broken.
 * Inked, it reads as a faded print on the page.
 */
export function VisionPlate({ vision, isInked = false, className }: VisionPlateProps): JSX.Element {
    return (
        <div className={classnames(styles.visionPlate, isInked && styles.inked, className)}>
            {vision.plateUrl !== undefined ? (
                <img className={styles.painting} src={vision.plateUrl} alt={vision.title} draggable={false} />
            ) : (
                <div className={styles.placeholder} role="img" aria-label={vision.title}>
                    <img className={styles.placeholderEmblem} src={toEssenceEmblemUrl(vision.essence)} alt="" draggable={false} />
                </div>
            )}
        </div>
    );
}
